<template>
    <div
        class="tw:flex"
        @click="toggleMenu"
        @keyup="toggleMenu"
    >
        <!-- Node Content -->
        <div :title="titleText">
            <span>{{ parseTitle(item.text) }}</span>
        </div>

        <!-- Node Actions/Icons -->
        <div>
            <e-icon v-if="item.completed" icon="check" />

            <locked-item
                v-if="hasPrerequisite && locked"
                :item="{
                    type: 'prerequisite',
                    namespace: item.type,
                    position: 'is-right',
                    prereqTitle,
                }"
            />

            <locked-item
                v-if="notVisible"
                :item="{
                    type: 'visibleAt',
                    namespace: item.type,
                    visibleAt: titleText,
                    position: 'is-right',
                }"
            />

            <locked-item
                v-if="isBreak"
                :item="{
                    type: 'break',
                    namespace: 'Week Break',
                    position: 'is-right',
                }"
            />
        </div>
    </div>
</template>

<script>
import LockedItem from '@/components/nested-list/LockedItem.vue';
import SectionTitleMixin from '@/mixins/SectionTitle.mixin.js';
import SidebarMixin from '@/mixins/Sidebar.mixin.js';
import moment from '@/plugins/vue-moment.js';

export default {
    // eslint-disable-next-line vue/no-reserved-component-names,vue/multi-word-component-names
    name: 'Section',

    components: { LockedItem },

    mixins: [SectionTitleMixin, SidebarMixin],

    props: {
        autoExpand: {
            type: String,
            required: false,
            default: '',
        },
    },

    emits: ['toggling-menu'],

    data: () => ({
        showingMenu: false,
    }),

    computed: {
        menuClass() {
            return this.showingMenu ? 'angle-down' : 'angle-right';
        },

        namespace() {
            return this.template ? 'SectionTemplates' : 'Sections';
        },

        section() {
            let week = null;

            if (this.isBreak) week = this.item.week_number;

            if (this.isWeek) week = this.item.display_week_number;

            return {
                type: this.item.section_type,
                week,
            };
        },

        isBreak() {
            return this.item.section_type === 'break';
        },

        isWeek() {
            return this.item.section_type === 'week';
        },

        isBreakOrWeek() {
            return this.isBreak || this.isWeek;
        },

        dateRange() {
            if (this.isBreakOrWeek && !this.$route.name.includes('temp')) {
                const carriesOverToNextYear = this.checkIfDateRangeCarriesOverToNextYear(
                    this.item.week_start,
                    this.item.week_end
                );
                const weekStart = this.accountForDST(this.item.week_start, 'start', carriesOverToNextYear);
                const weekEnd = this.accountForDST(this.item.week_end, 'end', carriesOverToNextYear);

                return `${weekStart}-${weekEnd}`;
            }

            return null;
        },

        /**
         * @returns {boolean}
         */
        isCurrentWeek() {
            return (
                this.item.type === 'section' &&
                this.item.section_type === 'week' &&
                moment().isBetween(this.item.week_start, this.item.week_end)
            );
        },
    },

    watch: {
        autoExpand(autoExpand) {
            this.search.do(this.item.items, 'items', item => {
                if (item.uuid === autoExpand) {
                    this.toggleMenu();
                }
            });
        },
    },

    mounted() {
        if (this.isCurrentWeek) this.toggleMenu();
    },

    methods: {
        toggleMenu() {
            if (this.locked && !this.canViewAdministratively) return null;

            this.showingMenu = !this.showingMenu;

            return this.$emit('toggling-menu', {
                display: this.showingMenu,
                item: this.item,
            });
        },

        accountForDST(date, weekParam, carriesOverToNextYear) {
            const method = weekParam === 'start' ? 'add' : 'subtract';

            const momentDate = moment.utc(date).tz(this.$timezone.name);

            momentDate[method](1, 'hours');

            if (carriesOverToNextYear) {
                return momentDate.format('MM/DD/YY');
            }

            return momentDate.format('MM/DD');
        },

        checkIfDateRangeCarriesOverToNextYear(weekStart, weekEnd) {
            return moment(weekEnd).isAfter(weekStart, 'year');
        },
    },
};
</script>
